import { WebPlayer } from 'ATVWebPlayer'

declare global {
  interface Window {
    WebPlayer?: {
      new (): WebPlayer
    }
  }
}

const deviceLoggerURL =
  '/gp/video/ajax/log-device-info.html/ref=atv_log_device_info'

const INTERVAL = 1000
const RETRIES = 60

export const loadWebPlayer = () =>
  new Promise<WebPlayer>((resolve, reject) => {
    const logAndReject = (errorType: 'Tag' | 'Loading' | 'Timeout') => {
      fetch(`${deviceLoggerURL}?description=DVWebPlayer${errorType}:LoadFailed`)
      reject(`DVWebPlayer:${errorType}:load:failure`)
    }

    const script = document.getElementById('player-script')
    if (window.WebPlayer) {
      resolve(new window.WebPlayer())
    } else if (!script) {
      logAndReject('Tag')
    } else {
      let attempt = 0

      let timeoutHandle: any
      const checkForPlayer = () => {
        if (attempt < RETRIES) {
          attempt += 1
          if (window.WebPlayer) {
            resolve(new window.WebPlayer())
          } else {
            timeoutHandle = setTimeout(checkForPlayer, INTERVAL)
          }
        } else {
          logAndReject('Timeout')
        }
      }

      checkForPlayer()

      script.onload = () => {
        clearTimeout(timeoutHandle)
        window.WebPlayer
          ? resolve(new window.WebPlayer())
          : logAndReject('Loading')
      }
    }
  })
